import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './DecarbonizatorPage.module.scss';

import { useSelectedContext } from 'context/contextSelector';
import UnauthApi from '../components/UnauthApi';
import UnauthDocumentation from '../components/UnauthDocumentation';
import AuthApi from '../components/AuthApi';
import DecarbonizatorBlock from 'components/DecarbonizatorBlock';
import ApiDocumentation from 'components/ApiDocumentation';

const DecarbonizatorPage = () => {
  const { user } = useSelectedContext((context) => context.user);
  const navigate = useNavigate();

  const [documentationTab, setDocumentationTab] = useState(false);

  const openDocumentation = () => {
    navigate('/');
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <UnauthDocumentation openDocumentation={openDocumentation} />
        {/* {user?.id ? (
          <>
            <DecarbonizatorBlock openDocumentation={openDocumentation} />
            <ApiDocumentation />
          </>
        ) : (
          <UnauthDocumentation openDocumentation={openDocumentation} />
        )} */}
      </div>
    </div>
  );
};

export default DecarbonizatorPage;
